import tw from 'tailwind-styled-components'

export const TwMain = tw.div`
  absolute
  left-0
  right-0
  bottom-0
  top-[132px]
  h-fit-content
  overflow-hidden
`

export const TwAnalyticsContainer = tw.div`
  flex
  flex-col
  w-full
  min-h-[400px]
  px-16
`

export const TwHeader = tw.div`
  flex
  w-full
  items-center
  mb-4 mt-10
  justify-between
  gap-20
  px-20
`

export const TwFunnelRow = tw.div`
  flex
  flex-wrap
  gap-16
  justify-start
`

export const TwResultLabel = tw.div`
  text-16
  font-semibold
`

export const TwCardBox = tw.div`
  bg-main-old
  rounded-[12px]
  flex
  flex-col
  items-start
  justify-start
  h-fit
  min-h-[150px]
`

export const TwChartContainer = tw(TwCardBox)`
  flex-[2]
  max-w-[710px]
  min-w-[710px]
  min-h-[314px]
`

export const TwTopBlock = tw.div`
  flex
  items-center
  gap-4
`

export const TwTopTitle = tw.div`
  text-16
  font-semibold
`

export const TwHelpContainer = tw.div`
  flex
  items-center
  gap-4
  text-14
  text-grey
  text-medium
`

export const TwPercentText = tw.div`
  flex
  text-[48px]
  font-semibold
  w-full
  justify-center
`

export const TwNoData = tw.div`
  text-14
  text-secondary
`

export const TwWipContent = tw.div`
  w-full
  h-full
  flex
  items-center
  justify-center
  text-14
  text-secondary
`

export const TwWipInner = tw.div`
  flex
  flex-col
  items-center
`

export const TwWipIcon = tw.span`
  text-24
  text-primary
`

export const TwWipTitle = tw.span`
  text-24
  text-primary
  font-semibold
  pb-4
`

export const TwWipSubtitle = tw.span`
  text-14
  text-secondary
`
